import React from 'react'
import { useSelector } from 'react-redux'
import { canCurrentUserCreateChannel } from 'data/users/selectors'
import ModalLink from 'components/Utils/Modal/Link'
import { CHANNEL_CREATE } from 'components/Utils/Modal/constants'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'
import IconButton from 'components/Utils/IconButton'
import { ChannelAddIcon } from 'components/Utils/Icons'

export const CreateChannelButton = () => {
  const canCreateChannel = useSelector(canCurrentUserCreateChannel)

  if (!canCreateChannel) {
    return null
  }

  return (
    <TooltipOnHover
      tooltipContent="Create a channel"
      placement="top"
      id="create-channel"
    >
      <ModalLink
        className="flexbox flexbox-align-center flexbox-no-shrink"
        to={CHANNEL_CREATE}
      >
        <IconButton colorScheme="grayOnGray" boxSize="smaller">
          <ChannelAddIcon size={16} className="flexbox-no-shrink" />
        </IconButton>
      </ModalLink>
    </TooltipOnHover>
  )
}
